import type { TypeBoxGraphQL } from '@/lib/graphql/types';
import type { TypeBoxProps } from '@/molecules/box';

export const boxTransformer = (box: TypeBoxGraphQL): TypeBoxProps => ({
  size: box.size,
  type: box.type,
  amount: box.amount,
});
